export default {
    UsersView: 1,
    UsersEdit: 1 << 1,
    UserSelfEdit: 1 << 2,
    UsersDelete: 1 << 3,
    RolesView: 1 << 4,
    RolesEdit: 1 << 5,
    RolesDelete: 1 << 6,
    ActionLogView: 1 << 7,
    ActionLogEdit: 1 << 8,
    WorkSpacesView: 1 << 9,
    WorkSpacesEdit: 1 << 10,
    WorkSpacesDelete: 1 << 11,
    ProjectsView: 1 << 12,
    ProjectsEdit: 1 << 13,
    ProjectsDelete: 1 << 14,
    DocumentsView: 1 << 15,
    DocumentsEdit: 1 << 16,
    DocumentsDelete: 1 << 17,
    SummaryReportsView: 1 << 18,
    SummaryReportsEdit: 1 << 19,
    SummaryReportsDelete: 1 << 20,
    MethodsView: 1 << 21,
    MethodsRun: 1 << 22,
    TasksView: 1 << 23,
    SettingsView: 1 << 24,
    SettingsEdit: 1 << 25,
    OntologicalModelView: 1 << 26,
    OntologicalModelEdit: 1 << 27,
    PasswordPolicyView: 1 << 28,
    PasswordPolicyEdit: 1 << 29
};
